const pillars = [
  {
    title: 'Agenda que respira com a loja',
    body: 'Unidades, barbeiros, bloqueios e fila — o cliente marca no site ou no WhatsApp sem ligar.',
    image:
      'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=1200&q=80',
    alt: 'Interior de barbearia com cadeiras',
  },
  {
    title: 'WhatsApp no fluxo, não à parte',
    body: 'Confirmação, lembrete e avaliação com créditos controlados. Chat com IA quando você quiser.',
    image:
      'https://images.unsplash.com/photo-1621605815971-fbc98d665033?auto=format&fit=crop&w=1200&q=80',
    alt: 'Barbeiro atendendo cliente',
  },
  {
    title: 'Caixa e comissão sem planilha',
    body: 'Fechamento do dia, pacotes, estoque e carteira do barbeiro no celular.',
    image:
      'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?auto=format&fit=crop&w=1200&q=80',
    alt: 'Detalhe de corte de cabelo',
  },
];

export default function Features() {
  return (
    <section id="produto" className="relative bg-ink py-24 lg:py-32">
      <div className="mx-auto max-w-content px-6 lg:px-8">
        <div className="max-w-xl">
          <p className="text-sm font-medium tracking-wide text-copper">Produto</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-bone sm:text-4xl text-balance">
            Feito para o ritmo da cadeira, não para planilha.
          </h2>
        </div>

        <div className="mt-16 space-y-20 lg:space-y-28">
          {pillars.map((item, index) => (
            <article
              key={item.title}
              className={[
                'grid items-center gap-10 lg:grid-cols-12 lg:gap-14',
                index % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : '',
              ].join(' ')}
            >
              <div className="lg:col-span-5">
                <h3 className="font-display text-2xl font-semibold tracking-tight text-bone sm:text-3xl text-pretty">
                  {item.title}
                </h3>
                <p className="mt-4 max-w-md text-base leading-relaxed text-mist">{item.body}</p>
              </div>
              <div className="relative overflow-hidden rounded-sm lg:col-span-7">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
